import SearchResultContainer from "../../../Components/Application/SearchResult/SearchResult"

const SearchResult = () => {
  return (
    <div className='page-body'>
      <SearchResultContainer />
    </div>
  )
}

export default SearchResult